/** An inline yes/no toggle for the administratie list. `value` null = field unknown in Odoo. */
export function ToggleCell({
  value,
  label,
  busy,
  onToggle,
}: {
  value: boolean | null;
  label: string;
  busy?: boolean;
  onToggle: (next: boolean) => void;
}) {
  if (value === null) return <span className="text-xs text-td-light">Onbekend</span>;
  return (
    <button
      type="button"
      role="switch"
      aria-checked={value}
      aria-label={label}
      disabled={busy}
      onClick={() => onToggle(!value)}
      className={`inline-flex items-center justify-center w-9 h-9 rounded-lg border transition disabled:opacity-60 ${
        value
          ? 'bg-green-100 border-green-300 text-green-700'
          : 'bg-white border-gray-300 text-gray-300 hover:border-td-blue hover:text-td-blue'
      }`}
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    </button>
  );
}
